import { useEffect, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './NotFound.module.css'

export function NotFound(): ReactElement {
  const { t } = useTranslation('common')

  useEffect(() => {
    // Signal to search engines not to index this page
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex'
    document.head.appendChild(meta)
    document.title = `${t('notFoundTitle')} | aether studio`
    return () => {
      document.head.removeChild(meta)
    }
  }, [t])

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <span className={styles.code}>404</span>
        <h1 className={styles.title}>{t('notFoundTitle')}</h1>
        <p className={styles.message}>{t('notFoundMessage')}</p>
        <a href="/" className={styles.link}>
          {t('notFoundBackHome')}
        </a>
      </div>
    </div>
  )
}
